import React from 'react';
import AreaTipoDivergenciaEnum from '../../../AreaTipoDivergenciaEnum';
import useBuildSubmitHandler from '../../../template/UseBuildSubmitHandler';
import TipoDivergenciasKey from '../../../TipoDivergenciasKey';
import TipoDivergenciasInfoKey from '../../../TipoDivergenciasInfoKey.';
import FinalStepTemplate, {
  useBuildDefaultInfoComponent,
} from '../../../template/FinalStepTemplate';
import {
  TipoDivergenciaComponent,
} from '../../../TiposDeDivergencias';
import { ReducaoGradeOPStep } from './ReducaoGradeOPStep';
import LabelValueWithSubtitle from '../../../components/LabelValueWithSubtitle';
import { PayloadProblemProps } from '../aumento-grade-op/AumentoGradeOPFinalStep';


const ReducaoGradeOPFinalStep: TipoDivergenciaComponent<PayloadProblemProps> = ({
  onSetStep,
  onBack,
  payload,
}) => {
  const onBackHandler = () => {
    onBack({
      component: ReducaoGradeOPStep as TipoDivergenciaComponent,
    });
  };

  const infoComponents = [
    ...useBuildDefaultInfoComponent(
      AreaTipoDivergenciaEnum.AJUSTE_MATERIA_PRIMA,
      'Redução de grade em OP'
    ),
    <LabelValueWithSubtitle
      label='Descrição do problema'
      value={`${payload.problemDescription}`}
      subtitle={''}
    />,
  ];

  const key = TipoDivergenciasKey.REDUCAO_DE_GRADE_EM_OP;
  const {
    loadingSave,
    loadingTipoDivergencia,
    handleSubmit,
  } = useBuildSubmitHandler(key, onSetStep);

  return (
    <FinalStepTemplate
      loading={loadingSave || loadingTipoDivergencia}
      onBack={onBackHandler}
      onSetStep={(step) => {
        handleSubmit(step, [        
          {
            tipo: TipoDivergenciasInfoKey.AJUSTE_MP,
            value: payload.problemDescription,
          },
        ]);
      }}
      progressValue={90}
      stepNumber={'3'}
      infoComponents={infoComponents}
    >
    </FinalStepTemplate>
  );
};

export default ReducaoGradeOPFinalStep;
